import { useLocation } from 'react-router'
import { languageService } from '#src/languageService.js'
import type { Language } from '#src/languageService.js'

/**
 * The active language, derived from the current route.
 * `/sv/...` pages are Swedish; everything else is the default language.
 *
 * Route-based (not localStorage) so it's deterministic during prerendering -
 * each prerendered page bakes in the correct language for its links and chrome.
 */
export function useLanguage(): Language {
  return languageService.languageFromPath(useLocation().pathname)
}
